module.exports = "/static/assets/dfe35552790fb5ff38c78a43f5e62f30.svg";